import React, { useState } from 'react';
import styles from './DeleteReviewerWithConfirmationModal.module.scss';
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from 'components/core';
import { Stack } from 'components/layout';

type Props = {
  deleteButton: string;
};

const DeleteReviewerWithConfirmationModal = ({ deleteButton }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onCancel = () => setIsModalOpen(false);
  const onDelete = () => setIsModalOpen(true);

  return (
    <>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <ModalHeader>Are you sure you want to delete this account?</ModalHeader>
        <ModalBody>
          <Stack spacing={4}>
            <Text>
              {`Deleting this account will remove the reviewer's personal details,
            prevent future logins, and erase their contact records from our
            systems.`}
            </Text>
            <Text>
              {`If they haven't collaborated on any reviews, their name will be replaced with "Deleted User [ID]"`}
            </Text>
            <Text className={styles.bold}>This action cannot be undone.</Text>
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button type="neutral" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <div
            // Safe as this content comes from the backend and not any user input
            dangerouslySetInnerHTML={{
              __html: deleteButton,
            }}
          ></div>
        </ModalFooter>
      </Modal>
      <Text>
        {`Deleting this account will remove the reviewer's personal details, prevent
      future logins, and erase their contact records from our systems. If they
      haven't collaborated on any reviews, their name will be replaced with
      "Deleted User [ID]"`}
      </Text>
      <Button className={styles.deleteButton} type="danger" onClick={onDelete}>
        Delete
      </Button>
    </>
  );
};

export default DeleteReviewerWithConfirmationModal;
